<template>
  <div class="orderPage">
    <div v-if="step == 1">
      <div class="title line">销售代客下单（销售业务订单）</div>
      <div class="shop_intro_wrap line">
        <h1>商品名称：Personalized series of women's clothing an...</h1>
        <div class="txt">
          <p>
            属性标签01：属性标签值最长的字数30个中文字，过长时可以分两行显示
          </p>
          <p>属性标签02：属性标签值</p>
          <p>属性标签03：属性标签值</p>
        </div>
        <h1>商品数量：<span>999</span></h1>
        <div class="set_wrap">
          <p>商品属性参数设置 <i class="iconfont icon-gengduo"></i></p>
        </div>
      </div>
      <!-- 收货信息 -->
      <div class="receive_goods_info_wrap line">
        <div class="form_wrap">
          <div class="list">
            <div class="tit flex-between">
              <span><i class="iconfont icon-bitian"></i> 购买人：</span>
              <span>快速选择常用客户 <i class="iconfont icon-right"></i></span>
            </div>
            <div class="item">
              <van-field readonly v-model="initData.buyName" placeholder="" />
            </div>
          </div>
          <div class="list list_mb">
            <div class="tit">
              <i class="iconfont icon-bitian"></i> 购买人联系方式：
            </div>
            <div class="item">
              <van-field
                v-model="initData.buyTel"
                placeholder="请输入收件人联系电话，20个字符内"
              />
            </div>
          </div>
          <div class="list">
            <div class="tit"><i class="iconfont icon-bitian"></i> 收件人：</div>
            <div class="item">
              <van-field
                v-model="initData.receiveName"
                placeholder="请输入收件人姓名，30个字符内"
              />
            </div>
          </div>
          <div class="list list_mb1">
            <div class="tit">
              <i class="iconfont icon-bitian"></i> 收件人联系方式：
            </div>
            <div class="item">
              <van-field
                v-model="initData.receiveTel"
                placeholder="请输入收件人联系电话，20个字符内"
              />
            </div>
          </div>
          <div class="list">
            <div class="tit">
              <i class="iconfont icon-address-outlined"></i> 选择配送地址
            </div>
            <div class="item">
              <van-field
                readonly
                v-model="initData.province"
                placeholder="选择省/直辖市"
              />
            </div>
            <div class="item">
              <van-field
                readonly
                v-model="initData.city"
                placeholder="选择城市"
              />
            </div>
            <div class="item">
              <van-field
                readonly
                v-model="initData.area"
                placeholder="选择所在区域"
              />
            </div>
          </div>
          <div class="mark">
            <h1>详细地址</h1>
            <div class="box">
              <van-field
                type="textarea"
                v-model="payInfo.detail"
                placeholder="请填写详细地址，50个字符内"
                maxlength="5  0"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 核算价格 -->
      <div class="price_total_wrap line flex-between">
        <div class="left">价格核算：</div>
        <div class="right"><span>¥</span>999.99</div>
      </div>
      <!-- 实际价格 -->
      <div class="other_price_wrap">
        <h1>实际订单价格：</h1>
        <div class="input_wrap flex-rowl">
          <div class="left"><i class="iconfont icon-bitian"></i>￥：</div>
          <div class="input_box">
            <van-field
              v-model="actualMoney"
              placeholder="输入数字，1~9个字符"
            />
          </div>
        </div>
        <div class="block">
          <h1>差额核算：</h1>
          <p>￥：999.99</p>
        </div>
        <div class="radio_wrap">
          <van-radio-group v-model="payType">
            <van-radio name="银行转账" shape="square">银行转账</van-radio>
            <van-radio name="支付宝" shape="square">支付宝</van-radio>
            <van-radio name="微信支付" shape="square">微信支付</van-radio>
            <van-radio name="其他第三方支付" shape="square"
              >其他第三方支付</van-radio
            >
          </van-radio-group>
        </div>
        <div class="pay_from_wrap form_wrap">
          <div class="item">
            <van-field
              v-model="payInfo.accountId"
              placeholder="银行账户名 or 支付宝ID or 微信ID or 其他第三方支付名称"
            />
          </div>
          <div class="item">
            <van-field
              v-model="payInfo.name"
              placeholder="开户行信息（银行转账以外的支付类型，请勿填写此项）"
            />
          </div>
          <div class="item">
            <van-field
              v-model="payInfo.account"
              placeholder="银行账号（银行转账以外的支付类型，请勿填写此项）"
            />
          </div>
          <div class="mark">
            <h1>备注信息：</h1>
            <div class="box">
              <van-field
                type="textarea"
                v-model="payInfo.mark"
                placeholder="如有需要，请填写备注说明，200个字符内"
                maxlength="200"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="bottom-operation_wrap">
        <div class="custom_btn next" @click="handleNext">
          下一步 <span><i class="iconfont icon-selected"></i></span>
        </div>
        <div class="return">←返回</div>
      </div>
    </div>
    <div class="confirm_wrap" v-else-if="step == 2">
      <div class="title line">销售代客下单（销售业务订单）</div>
      <div class="content line">
        <div class="block">
          <h1>商品名称：Personalized series of women's clothing an...</h1>
          <div class="txt">
            <p>
              属性标签01：属性标签值最长的字数30个中文字，过长时可以分两行显示
            </p>
            <p>属性标签02：属性标签值</p>
            <p>属性标签03：属性标签值</p>
          </div>
          <h1>商品数量：999</h1>
        </div>
        <div class="block">
          <h1>商品名称：Personalized series of women's clothing an...</h1>
          <div class="txt">
            <p>
              属性标签01：属性标签值最长的字数30个中文字，过长时可以分两行显示
            </p>
          </div>
          <h1>商品数量：999</h1>
        </div>
        <div class="block">
          <h1>商品名称：Personalized series of women's clothing an...</h1>
          <div class="txt">
            <p>
              属性标签01：属性标签值最长的字数30个中文字，过长时可以分两行显示
            </p>
            <p>属性标签02：属性标签值</p>
          </div>
          <h1>商品数量：999</h1>
        </div>
        <div class="block">
          <h1>商品名称：Personalized series of women's clothing an...</h1>
          <div class="txt">
            <p>
              属性标签01：属性标签值最长的字数30个中文字，过长时可以分两行显示
            </p>
            <p>属性标签02：属性标签值</p>
          </div>
          <h1>商品数量：999</h1>
        </div>
      </div>
      <div class="content line">
        <div class="address_wrap">
          <div class="item flex-rowl">
            <p>购买人：</p>
            <p>测试用户</p>
          </div>
          <div class="item flex-rowl">
            <p>购买人联系方式：</p>
            <p>13911116666</p>
          </div>
          <div class="item flex-rowl">
            <p>收件人：</p>
            <p>测试用户</p>
          </div>
          <div class="item flex-rowl">
            <p>收件人联系方式：</p>
            <p>13911116666</p>
          </div>
          <div class="item flex-rowl">
            <p>测试省/直辖市</p>
            <p>测试区域</p>
          </div>
          <div class="txt">
            详细地址信息，预设输入时最多输入50个中文字，在这里显示时
            可以换行，最多三行
          </div>
        </div>
      </div>
      <div class="content line">
        <div class="price flex-between">
          <p>价格核算：</p>
          <p><span>￥</span>999.99</p>
        </div>
      </div>
      <div class="content line">
        <div class="price flex-between">
          <p>价格核算：</p>
          <p><span>￥</span>999.99</p>
        </div>
        <div class="price_btm flex-between">
          <p>差额：</p>
          <p><span>￥</span>200.00</p>
        </div>
      </div>
      <div class="pay_wrap">
        <div class="tit">支付方式：银行转账</div>
        <div class="block">
          <p>银行账户名</p>
          <p>开户行</p>
          <p>银行账号</p>
        </div>
        <div class="mark">
          <h1>备注信息：</h1>
          <p>无备注信息</p>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="bottom-operation_wrap">
        <div class="custom_btn next" @click="handleSubmit">
          确认 <span><i class="iconfont icon-selected"></i></span>
        </div>
        <div class="return" @click="handleReturn">←返回</div>
      </div>
    </div>

    <!-- 支付确认弹窗  -->
    <van-overlay :show="isShow">
      <div class="popup-wrap">
        <div class="close" @click="onClickHide">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <div class="popup-main">
          <div class="scroll_wrap" style="height: 36vh">
            <div class="column">
              <div class="tit">属性标签名称，例如：颜色</div>
              <div class="select_list">
                <div
                  class="select_item flex-between"
                  :class="{ active: index === shopColorCheck }"
                  v-for="(item, index) in shopColor"
                  :key="index + 'a'"
                  @click="handleSelect('color', index)"
                >
                  <div class="main flex-rowl">
                    <div class="pic">
                      <van-image
                        width="100%"
                        height="100%"
                        :src="item.src"
                        v-if="item.isImportant"
                      />
                      <van-image
                        width="100%"
                        height="100%"
                        :src="item.src"
                        v-else
                      />
                    </div>
                    <span>{{ item.txt }}</span>
                  </div>
                  <div class="check flex-rowr" v-if="index === shopColorCheck">
                    <i class="iconfont icon-3tuihuanhuozhengcegouxuan"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="tit">属性标签名称，例如：尺寸</div>
              <div class="select_list">
                <div
                  class="select_item flex-between"
                  :class="{ active: index === shopSizeCheck }"
                  v-for="(item, index) in shopSize"
                  :key="index + 'a'"
                  @click="handleSelect('size', index)"
                >
                  <div class="main">{{ item.txt }}</div>
                  <div class="check" v-if="index === shopSizeCheck">
                    <i class="iconfont icon-3tuihuanhuozhengcegouxuan"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="step-wrap flex-rowc">
            <van-stepper v-model="stepVal" button-size="34px" />
          </div>
          <div class="settlement flex-between">
            <div class="txt1">价格核算：</div>
            <div class="txt2"><span>￥ </span>999.99</div>
          </div>
          <div class="query btn" @click="handleQuery">确认</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "cShopOrder",
  data() {
    return {
      actualMoney: "", // 实际价格
      payType: "", // 选择支付方式

      initData: {
        province: "",
        city: "",
        area: "",
        detail: "",
      },

      payInfo: {
        accountId: "",
        name: "",
        account: "",
        mark: "",
      },
      step: 1,
      isShow: false,

      shopColor: [
        {
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
          txt: "属性标签值",
          isImportant: true,
        },
        {
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
          txt: "属性标签值",
          isImportant: false,
        },
      ],
      shopColorCheck: "",
      shopSize: [
        {
          txt: "XL",
        },
        {
          txt: "XXL",
        },
      ],
      shopSizeCheck: "",
      stepVal: 1,
    };
  },
  created() {},
  methods: {
    onClickHide() {
      this.isShow = false;
    },
    handleNext() {
      this.isShow = true;
    },
    handleSelect(type, index) {
      if (type == "color") {
        this.shopColorCheck = index;
      }
      if (type == "size") {
        this.shopSizeCheck = index;
      }
    },
    handleQuery() {
      this.step = 2
      this.onClickHide()
    },
    handleSubmit() {},
    handleReturn() {
      this.$router.back()
    }
  },
};
</script>
<style lang="less" scoped>
.orderPage {
  box-sizing: border-box;
  font-size: 24px;
  color: #3c3c3c;
  padding-bottom: 380px;
  .line {
    border-bottom: 9px solid #f5f5f5;
  }
  .title {
    padding: 48px 42px 33px;
  }

  .shop_intro_wrap {
    padding: 40px 57px 83px;
    font-size: 20px;
    h1 {
      font-size: 20px;
      margin-bottom: 9px;
    }
    p {
      font-size: 18px;
      color: #969696;
      margin-bottom: 15px;
      line-height: 30px;
    }
    .set_wrap {
      padding: 25px 0;
      font-size: 18px;
      color: #000000;
      border-bottom: 1px dashed #c3c3c3;
      text-align: left;
      p {
        padding: 0 15px;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        border-radius: 30px;
        border: 1px solid #aaaaaa;
      }
    }
  }

  .receive_goods_info_wrap {
    padding: 60px 70px 90px;
    color: #333333;
  }

  .price_total_wrap {
    padding: 70px 57px;
    .right {
      font-size: 40px;
      span {
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }

  .other_price_wrap {
    padding: 50px 57px;
    h1 {
      margin-bottom: 50px;
    }
    .input_wrap {
      .left {
        font-size: 30px;
        .iconfont {
          color: #c63520;
        }
      }
      .input_box {
        width: 560px;
        height: 60px;
        background: #f0f0f0;
        border: none;
        padding: 0 27px;
      }
    }
    .block {
      margin: 70px 0 80px;
      p {
        font-size: 30px;
      }
    }
    .radio_wrap {
      margin-bottom: 70px;
      /deep/ .van-radio {
        margin-bottom: 20px;
      }
    }
  }
  .bottom-operation_wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 70px 125px 100px;
    .custom_btn {
      width: 500px;
      height: 60px;
      line-height: 60px;
      background: #1e1e1e;
      border-radius: 0;
      margin: 0 auto 60px;
    }
    .return {
      font-size: 26px;
      color: #333333;
      text-align: center;
    }
  }

  .form_wrap {
    width: 600px;
    margin: auto;
    .list_mb {
      margin-bottom: 120px;
    }
    .list_mb1 {
      margin-bottom: 70px;
    }
    .tit {
      margin-bottom: 40px;
      .icon-address-outlined {
        font-size: 30px;
        color: #515151;
        margin-left: -10px;
      }
      .icon-bitian {
        color: #c63520;
      }
    }
    .item {
      border-bottom: 1px dashed #c3c3c3;
      height: 73px;
      padding: 0 10px;
      margin-bottom: 32px;
    }
    /deep/ .van-cell {
      padding: 0;
      height: 100%;
    }
    /deep/ .van-field__body {
      font-size: 12px;
      height: 100%;
    }
    .mark {
      h1 {
        margin-bottom: 20px;
      }
      .box {
        width: 600px;
        height: 190px;
        background: #fafafa;
        padding: 19px 22px;
        box-sizing: border-box;
        /deep/ .van-cell {
          background: transparent;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
    }
  }

  .confirm_wrap {
    .content {
      padding: 39px 42px 47px;
      .block {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
        h1 {
          font-size: 20px;
          color: #3c3c3c;
          margin-bottom: 9px;
        }
        .txt {
          margin-bottom: 19px;
          p {
            font-size: 18px;
            color: #969696;
            line-height: 30px;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .price {
        font-size: 24px;
        p {
          &:last-child {
            font-size: 40px;
            span {
              font-size: 24px;
              margin-right: 10px;
            }
          }
        }
      }
      .price_btm {
        margin-top: 50px;
        font-size: 24px;
        p {
          &:last-child {
            font-size: 20px;
            span {
              font-size: 22px;
            }
          }
        }
      }
    }
    .address_wrap {
      font-size: 22px;
      .item {
        margin-bottom: 30px;
        p {
          &:first-child {
            width: 190px;
          }
        }
      }
      .txt {
        font-size: 20px;
        line-height: 30px;
      }
    }
    .pay_wrap {
      padding: 42px 57px 0;
      font-size: 24px;
      box-sizing: border-box;
      .tit {
        margin-bottom: 70px;
      }
      .block {
        font-size: 22px;
        color: #aaaaaa;
        margin-bottom: 59px;
        padding-left: 39px;
        p {
          margin-bottom: 35px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .mark {
        font-size: 22px;
        padding-left: 39px;
        p {
          color: #aaaaaa;
          margin-top: 28px;
        }
      }
    }
  }

  .popup-wrap {
    height: 82vh;
    width: 100%;
    background: #fff;
    position: absolute;
    bottom: 0;
    .close {
      position: absolute;
      left: 50%;
      top: -90px;
      color: #fff;
      .icon-jujueweituo {
        font-size: 50px;
      }
    }
    .popup-main {
      padding-top: 97px;
      .scroll_wrap {
        padding-bottom: 40px;
        box-sizing: border-box;
        overflow-y: scroll;
        .column {
          width: 600px;
          margin-left: 48px;
          margin-bottom: 80px;
          .tit {
            font-size: 24px;
            color: #3c3c3c;
            position: relative;
            padding-left: 26px;
            margin-bottom: 50px;
            &::before {
              position: absolute;
              width: 5px;
              height: 30px;
              top: 50%;
              transform: translateY(-50%);
              background: #ff0042;
              display: inline-block;
              content: "";
              left: -4px;
            }
          }
          .select_list {
            .select_item {
              width: 600px;
              min-height: 100px;
              border: 1px solid #c1c1c1;
              border-radius: 30px;
              padding: 20px 15px 20px 27px;
              box-sizing: border-box;
              font-size: 22px;
              color: #3c3c3c;
              margin-bottom: 20px;
              .main {
                width: 480px;
                flex-shrink: 0;
                .pic {
                  width: 90px;
                  margin-right: 30px;
                }
              }
              &.active {
                background: #f0f0f0;
              }
              &:last-child {
                margin-bottom: 0;
              }
              .icon-3tuihuanhuozhengcegouxuan {
                font-size: 42px;
              }
            }
          }
        }
      }
      .step-wrap {
        height: 160px;
        border-bottom: 1px dashed #3c3c3c;
        box-shadow: 0 -1px 8px 2px rgba(0, 0, 0, 0.05);
        .van-stepper {
          width: 750px;
          padding: 0 48px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
        }
      }
      .settlement {
        width: 700px;
        margin: auto;
        padding: 60px 23px;
        border-bottom: 1px dashed #3c3c3c;
        box-sizing: border-box;
        .txt1 {
          font-size: 24px;
          color: #3c3c3c;
        }
        .txt2 {
          font-size: 40px;
          text {
            font-size: 24px;
          }
        }
      }
      .query {
        width: 500px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        background: #1e1e1e;
        font-size: 26px;
        color: #fff;
        margin: 85px auto 0;
      }
    }
  }
}
</style>